angular.module("app").directive("topColorsTherapeuticArea", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbTopColorsTherapeuticArea/dbTopColorsTherapeuticAreaView.html",
    link: link,
    scope: {
      therapeuticColorData: "="
    }
  };
});
